<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      size="ad-log"
      :contentStyle="{'height': '100%', 'display': 'flex', 'flex-direction': 'column'}"
      :footer="false">
  <template #header>
      <span>操作日志</span><span class="modal-secondary-title">{{ name }}</span>
    </template>
    <template #content>
      <app-base-main no-padding parentTable :table-shadow="false">
        <template #filter-group>
              <div style="margin-bottom: 12px;">
              
              <gj-radio-group
                v-model="radioActive"
                :options="[
                    {id:0,text:'手动调整'},
                    {id:1,text:'分时策略'},
                    {id:2,text:'自动规则'},
                ]"
            ></gj-radio-group>
          </div>

          <app-filter-group :reset="false" @query="$gjQuery" :isBr="true" :fixWidth="200">
<!--            操作对象类型-->
            <gj-select
                v-model="filter.objectType"
                :options="objectTypeOptions"
                placeholder="操作对象类型"
                width="120px"
            ></gj-select>
            <template>
              <!--            操作类型 手动-->
              <gj-select
                  v-if="radioActive === 0"
                  v-model="filter.operatingType"
                  :options="operationTypeOptions"
                  placeholder="操作类型"
                  width="140px"
              ></gj-select>
              <!--            操作类型 分时策略-->
              <gj-select
                  v-else-if="radioActive === 1"
                  v-model="filter.opType"
                  :options="operationTypeOptions"
                  placeholder="操作类型"
                  width="140px"
              ></gj-select>
              <!--            操作类型 自动规则-->
              <gj-select
                  v-else
                  v-model="filter.ruleType"
                  :options="operationTypeOptions"
                  placeholder="操作类型"
                  width="140px"
              ></gj-select>
            </template>

<!--            广告活动-->
            <ad-campaign-select
                width="180px"
                class="campaign-select"
                v-if="isCampaign"
                v-model="filter.campaignIds"
                :marketId="marketId"
                :adType="adType"
                :isVirtual="false"
                @change="campaignSelectChange($event)">
            </ad-campaign-select>
<!--            广告组-->
            <ad-group-select
                class="group-select"
                v-if="isGroup"
                ref="groupSelect"
                v-model="filter.groupIds"
                :marketId="marketId"
                :campaignId="campaignId"
                :adType="adType">
            </ad-group-select>
<!--            对象名称-->
            <gj-input v-model="filter.objectName" width="160px" placeholder="操作对象名称"></gj-input>
<!--            操作用户-->
            <gj-creator-select style="margin-left: 8px;" v-model="filter.userId" placeholder="操作用户" v-if="radioActive === 0"></gj-creator-select>
<!--            时间-->
            <gj-select-date-picker
              type="daterange"
              v-model="filter.date"
              :options="options.date"
              :dateClearable="false"
            ></gj-select-date-picker>
          </app-filter-group>
        </template>

        <template #table>

          <manual-table v-if="radioActive === 0" ref="manualTable" :model="manualModel"></manual-table>

          <auto-table v-if="radioActive === 1" ref="autoTable" :model="autoModel"></auto-table>

          <automatic-rule-table v-if="radioActive === 2" ref="automaticRuleTable" :model="automaticRuleModel"></automatic-rule-table>



        </template>

      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
  import AdCampaignSelect from "@/views/modules/ad/common/components/ad-campaign-select.vue"
  import AdGroupSelect from "@/views/modules/ad/common/components/ad-group-select.vue"
  import {subDays} from 'date-fns';
  import { convertToDate } from "@/utils/date.util";
  import {defaultVal, isMeaningful, isMeaningless} from "@/utils/common";
  import { AdLog } from "@/views/modules/ad/common/enum.js"
  import { isMeaninglessMixin, modalMixIn, queryMixin, isMeaningfulMixin } from "@/minxins";
  import {AdStrategyEnum} from "@/views/modules/ad/strategy/common/enum";

  import AutoTable from "@/views/modules/ad/common/modal/log/components/auto-table"
  import ManualTable from "@/views/modules/ad/common/modal/log/components/manual-table"
  import AutomaticRuleTable from "@/views/modules/ad/common/modal/log/components/automatic-rule-table.vue"
import { option } from '../../../ad-automate/const';


  export default {
    name: "app-ad-log-modal",
    mixins: [modalMixIn, isMeaninglessMixin, isMeaningfulMixin],
    components: {AdCampaignSelect, AdGroupSelect, AutoTable, ManualTable, AutomaticRuleTable },
    props: {
      // 广告类型
      adType: {
        type: String,
        required: true
      },
      name: {
        default: ''
      },
      marketId: {
        required: true
      },
      campaignId: {
        default: null
      },
      groupId: {
        default: null
      },
      // 操作对象类型
      objectType: {
        type: Number,
        default: null
      },
      // 操作对象名称
      objectName: {
        type: String,
        default: ""
      },
      radioActiveProp: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        radioActive: this.radioActiveProp,// 查询类型 0：手动调整 1：分时策略  2: 自动规则
        isCampaign: false,
        isGroup: false,
        filter: {
            campaignIds: [], // 广告活动id集合
            groupIds: [], // 广告组id集合
            objectName: null, // 操作对象名称
            objectType: this.objectType, // 操作对象类型
            operatingType: null, // 操作类型 手动
            opType:null, // 操作类型 分时策略
            ruleType: null,  //操作类型  自动规则
            result: null, // 操作结果
            userId: null, // 操作人Id
            date: {
                key: AdLog().createDateCell.market,
                value: [subDays(new Date(), 6), new Date()],
            },
        },
        options: { // 枚举
          // 操作对象类型
          objectType: AdLog().objOptions,
          // 时间
          date: AdLog().createDateOptions,
          // 操作类型  手动
          optOptionsCustom: [],
          // 操作类型  自动
          opTypeOption: AdStrategyEnum.opTypeOption,
        },
        selectObjectType: null,   //记录操作对象text
      }
    },
    computed:{
      manualModel(){
        // 手动
        // 广告类型
        let typeSign = this.filter.operatingType?.split('-') || [];
        return {
          marketId: this.marketId,// 店铺id
          adsType: AdLog().adsType[this.adType],//SP: 0    SB: 1    SD: 2,
          objectType: this.filter.objectType,//// 操作对象类型
          operatingType: typeSign[0],// 操作类型
          content: typeSign[1],// 操作内容
          campaignIds: this.filter.campaignIds,// 已选广告活动
          groupIds: this.filter.groupIds,// 已选广告组
          objectName: this.filter.objectName,// 操作对象名称
          userId: this.filter.userId,// 操作人id
          createDateType: this.filter.date.key,// 时间类型 system: 0,market: 1,
          startDate: isMeaningful(this.filter.date.value) ? convertToDate(this.filter.date.value[0]) : null,// 开始时间
          endDate: isMeaningful(this.filter.date.value) ? convertToDate(this.filter.date.value[1]) : null,// 结束时间
        }
      },
      autoModel(){
        return {
          marketId: this.marketId,// 店铺id
          objectType: this.objectTypeOptions.find(r => r.id===this.filter.objectType)?.id2,//// 操作对象类型
          operateType: defaultVal(this.filter.opType, null),// 操作类型
          campaignIds: this.filter.campaignIds,// 已选广告活动
          groupIds:this.filter.groupIds,// 已选广告组
          objectName: this.filter.objectName,// 操作对象名称
          createDateType: this.filter.date.key,// 时间类型 system: 0,market: 1,
          startDate: isMeaningful(this.filter.date.value) ? convertToDate(this.filter.date.value[0]) : null,// 开始时间
          endDate: isMeaningful(this.filter.date.value) ? convertToDate(this.filter.date.value[1]) : null,// 结束时间
        }
      },
       automaticRuleModel(){
         // 时间类型 system: 0,market: 1,
        return {
          marketIdList: this.marketId ? [this.marketId] : [],// 店铺id
          objectType: defaultVal(this.filter.objectType, null),//// 操作对象类型
          operateType: defaultVal(this.filter.ruleType, null),// 操作类型
          campaignIds: this.filter.campaignIds,// 已选广告活动
          groupIds:this.filter.groupIds,// 已选广告组
          objectName: this.filter.objectName,// 操作对象名称
          createDateType: this.filter.date.key,// 时间类型 system: 0,market: 1,
          startTime: isMeaningful(this.filter.date.value) ? convertToDate(this.filter.date.value[0]) : null,// 开始时间
          endTime: isMeaningful(this.filter.date.value) ? convertToDate(this.filter.date.value[1]) : null,// 结束时间
        }

      },
      // 操作对象对象类型选项
      objectTypeOptions(){
        if(this.radioActive === 0){
          return AdLog().objOptions;
        }else if (this.radioActive === 1) {
          return AdLog().objOptions.filter(r => r.isShare);
        } else {
          return AdStrategyEnum.executeObjectTypeOption;
        }
      },
        // 操作类型选项
      operationTypeOptions(){
        if (this.radioActive === 0) {
            return this.options.optOptionsCustom;
        }else if (this.radioActive === 1) {
            return this.options.opTypeOption;
        }else {
           return AdStrategyEnum.operationTypeOption;
        }
      },
    },
    watch: {
      // 切换手动、自动时
      radioActive:{
        handler(val){
          if (val === 2) {    //自动规则
             // 切换回自动规则，objectType需要转换
            if (isNaN(Number(this.filter.objectType)) === false) {  //
              let typeText = AdLog().getObjText(this.filter.objectType);
              const info = AdStrategyEnum.executeObjectTypeOption.find(e => e.text === typeText);
               let typeId = info  ? info.id : null;
              if (typeId !== null) {
                this.filter.objectType = typeId;
              }else {
                 this.filter.objectType = null;
              }
            }

          }else {
            // 从自动规则切换回来，objectType需要转换
            if (isNaN(Number(this.filter.objectType)) === true) {  //
              let typeId = AdLog().getObjId(this.selectObjectType);
              if (typeId !== null) {
                this.filter.objectType = typeId;
              }else {
                 this.filter.objectType = null;
              }
            }
             //保留原逻辑
             // 若已选对象类型在另一个的选项里面没有，则清空
            if(isMeaningless(this.objectTypeOptions.find(r => r.id === this.filter.objectType))){
              this.filter.objectType = null;
            }

          }
          this.filter.operatingType = null;// 操作类型 手动
          this.filter.opType = null;// 操作类型  分时策略
          this.filter.ruleType = null;  // 操作类型  自动规则

        }
      },
      // 监听操作对象
      'filter.objectType': {
        handler(val) {
          this.filter.operatingType = null;
          this.filter.opType = null;
          this.filter.ruleType = null;
          // this.filter.campaignIds = [];
          // this.filter.groupIds = [];
          if (this.radioActive !== 2) {   //原有逻辑不变
            this.selectObjectType = AdLog().getObjText(val);
            this.options.optOptionsCustom = [];
            // 操作类型处理
            this.options.optOptionsCustom = AdLog().optOptionsCustom(val);
            // 广告活动、广告组处理
            this.isCampaign = val ? AdLog().getObjOptions(val).isCampaign : true;
            this.isGroup = val ? AdLog().getObjOptions(val).isGroup : true;
          }else {   //自动规则逻辑
            this.selectObjectType = AdStrategyEnum.getObjectTypeText[val] ? AdStrategyEnum.getObjectTypeText[val] : null;
            if (val === 'campaign') {
                this.isCampaign = false;
                this.isGroup = false;
            }else if (val === 'group') {
                this.isCampaign = true;
                this.isGroup = false;
            }else {
                this.isCampaign = true;
                this.isGroup = true;
            }
          }

        },
        immediate: true
      }
    },
    filters: {
      optionsText(val, options) {
        const item = options.find(e => e.id == val);
        return item ? item.text : val
      },
    },
    methods: {
      $gjQuery() {
        if(this.radioActive === 0){
          // 手动
          this.$refs.manualTable.$gjQuery()
        }else if(this.radioActive === 1){
          // 分时策略
          this.$refs.autoTable.$gjQuery()
        }else {
           // 自动规则
          this.$refs.automaticRuleTable.$gjQuery()
        }
      },
      // 广告活动下拉改变
      campaignSelectChange(e) {
        this.filter.groupIds = []
        let afferent = {
          campaignIds: e
        }
        this.$refs.groupSelect.getOptions(this.adType, afferent)
      },
    },
    created() {
      this.filter.objectType = this.objectType;
      this.filter.campaignIds = this.campaignId ? [ this.campaignId ] : [];
      this.filter.groupIds = this.groupId ? [ this.groupId ] : [];
      // console.log('%czs','color: red; font-size: 60px', this.objectName);
      this.filter.objectName = this.objectName;
    }
  }
</script>

<style scoped lang="scss">
.campaign-select, .group-select {
  margin-left: 8px;
}
/deep/.vxe-table--border-line{
  border: 1px solid #d8dadd !important;
}
/deep/.vxe-header--column {
  background: #f6f8fb !important;
}
.el-icon-arrow-down {
  cursor: pointer;
}
</style>
